// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"styles_scrollContainer__3RWBK"};